import { render, staticRenderFns } from "./parentParticular.vue?vue&type=template&id=217ee238&scoped=true"
import script from "./parentParticular.vue?vue&type=script&lang=js"
export * from "./parentParticular.vue?vue&type=script&lang=js"
import style0 from "./parentParticular.vue?vue&type=style&index=0&id=217ee238&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "217ee238",
  null
  
)

export default component.exports